import { MediaTablet } from 'api/const/MediaQuery'
import clsx from 'clsx'
import { Service } from 'components/pagine'
import useMediaQuery from 'hook/useMediaQuery'
import React, { FC, useEffect, useState } from 'react'
import { ServicesTableBody } from './ServicesTableBody'


interface iCustomTableService {
    data:Service[]
    askMatch: (serviceId:string) => void
    selectedId?: string
    setSelectedId?: (selectedId: string) => void
    isLoading:boolean,
    setIsLoading:(par:boolean)=> void
  }


export const ServicesTable:FC <iCustomTableService>=({  setIsLoading,data,askMatch, selectedId,setSelectedId, isLoading })=> {
  const tablet = useMediaQuery(MediaTablet)

 
    return (
    <div className={clsx("d-flex flex-column mt-4 tableContainer mb-5")}
    style={{opacity: isLoading ? 0.3 : 1}}
    >
       <ServicesTableBody  setIsLoading={setIsLoading} data={data} isLoading={isLoading}  askForaMatch={askMatch} selectedId={selectedId} setSelectedId={setSelectedId}/> 
    </div>
  )
}
